import "../../styles/blocks/linklist/linklist.scss";

import React from "react";
import {Link} from "gatsby";
import PropTypes from "prop-types";

import IconArrowDown from "../../icons/IconArrowDown";

const ThemeManualNavigation = ({categories, activeArticleId, onArticleSelect}) => {
    if (!categories.length) {
        return null;
    }

    return (
        <nav className="linklist theme-manual-navigation" aria-label="Manual sections">
            <div className="linklist__wrapper">
                {categories.map((category, categoryIndex) => (
                    <details
                        className="theme-manual-navigation__category"
                        key={`${category.title}-${categoryIndex}`}
                    >
                        <summary className="linklist__button theme-manual-navigation__summary">
                            {category.title}
                            <span className="arrow" aria-hidden="true">
                                <IconArrowDown />
                            </span>
                        </summary>

                        <div className="linklist__content theme-manual-navigation__links">
                            {category.articles.map(article => (
                                <Link
                                    className={`linklist__link ${article.id === activeArticleId ? "active" : ""}`}
                                    key={article.id}
                                    to={`#${article.id}`}
                                    onClick={() => onArticleSelect(article.id)}
                                >
                                    {article.title}
                                </Link>
                            ))}
                        </div>
                    </details>
                ))}
            </div>
        </nav>
    );
};

ThemeManualNavigation.propTypes = {
    categories: PropTypes.array.isRequired,
    activeArticleId: PropTypes.string,
    onArticleSelect: PropTypes.func.isRequired,
};

export default ThemeManualNavigation;
